export const RavelEmoji = {
    "red-circle": "🔴",
    "orange-circle": "🟠",         
    "yellow-circle": "🟡",
    "green-circle": "🟢",
    "blue-circle": "🔵",
    "purple-circle": "🟣",
    "black-circle": "⚫️",
    "white-circle": "⚪️",
    "brown-circle": "🟤",
    "red-square": "🟥",
    "orange-square": "🟧",         
    "yellow-square": "🟨",
    "green-square": "🟩",
    "blue-square": "🟦",
    "purple-square": "🟪",
    "black-square": "⬛️",
    "white-square": "⬜️",
    "brown-square": "🟫",
    "flower": "🏵",
    "hamburger": "🍔",
    "red": "#ff0000",
    "orange": "#ff8800",         
    "yellow": "#ffff00",
    "green": "#00ff00",
    "blue": "#0000ff",
    "purple": "#ff00ff",
    "black": "#000000",
    "white": "#ffffff",
    "brown": "#5f3e3e",
    "donut": '🍩',
    "roundColors": [
        "🔴","🟠","🟡","🟢","🔵","🟣","⚫️","⚪️","🟤"
    ],
    "squareColors": [
        "🟥","🟧","🟨","🟩","🟦","🟪","⬛️","⬜️","🟫"
    ],
    "roundSelection": [
        '🌞','🌝','🌑','🌒','🌓','🌔','🌕','🌖','🌗','🌘', '📀','🌰','🍎','🍏','🏀','⚽','⚾','🎾','🎱','🍪','🍥','🍘','🍅','🌼','🌐','🌞','🌍','🌎','🌏','💿'
    ],
    "animals": [
        "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐻‍❄️", "🐨", "🐯", "🦁", "🐮", "🐷", "🐵", "🐔", "🐧", "🐦", "🐤", "🦄", "🐣", "🐥", "🦆", "🦅", "🦉", "🦇", "🐺", "🐗", "🐴",  "🐝", "🪱", "🐛", "🦋", "🐌", "🐞", "🐜", "🪰", "🪲", "🪳", "🦟", "🦗", "🕷", "🕸", "🦂", "🐢", "🐍", "🦎", "🦖", "🦕", "🐙", "🦑", "🦐", "🦞", "🦀", "🐡", "🐠", "🐟", "🐬", "🐳", "🐋", "🦈", "🐊", "🐅", "🐆", "🦓", "🦍", "🦧", "🦣", "🐘", "🦛", "🦏", "🐪", "🐫", "🦒", "🦘", "🦬", "🐃", "🐂", "🐄", "🐎", "🐖", "🐏", "🐑", "🦙", "🐐", "🦌", "🐕", "🐩", "🦮", "🐕‍🦺", "🐈", "🐈‍⬛", "🪶", "🐓", "🦃", "🦤", "🦚", "🦜", "🦢", "🦩", "🕊", "🐇", "🦝", "🦨", "🦡", "🦫", "🦦", "🦥", "🐁", "🐀", "🐿", "🦔"
    ],
    "devices": [
        '💿','📀','💽','💾','💻','📱','📞','📟','📠','📡',
        '📺','📻','🔊','🔉','🔈','🔇'
    ],
    "buildings": [
        "🏢", "🪨", "🏚️", "🪵", "🏛️", "🏡", "🏬"
    ],
    "emojis": [ 	'😄','😃','😀','😊','😉','😍','😘','😚','😗','😙','😜','😝','😛','😳','😁','😔','😌','😒','😞',
        '😣','😢','😂','😭','😪','😥','😰','😅','😓','😩','😫','😨','😱','😠','😡','😤','😖','😆','😋','😷','😎','😴',
        '😵','😲','😟','😦','😧','😈','👿','😮','😬','😐','😕','😯','😶','😇','😏','😑','👲','👳','👮','👷','💂','👶',
        '👦','👧','👨','👩','👴','👵','👱','👼','👸','😺','😸','😻','😽','😼','🙀','😿','😹','😾','👹','👺','🙈','🙉',
        '🙊','💀','👽','💩','🔥','✨','🌟','💫','💥','💢','💦','💧','💤','💨','👂','👀','👃','👅','👄','👍','👎','👌',
        '👊','✊','✌','👋','✋','👐','👆','👇','👉','👈','🙌','🙏','☝','👏','💪','🚶','🏃','💃','👫','👪','👬','👭',
        '💏','💑','👯','🙆','🙅','💁','🙋','💆','💇','💅','👰','🙎','🙍','🙇','🎩','👑','👒','👟','👞','👡','👠','👢',
        '👕','👔','👚','👗','🎽','👖','👘','👙','💼','👜','👝','👛','👓','🎀','🌂','💄','💛','💙','💜','💚','💔',
        '💗','💓','💕','💖','💞','💘','💌','💋','💍','💎','👤','👥','💬','👣','💭','🐶','🐺','🐱','🐭','🐹','🐰','🐸',
        '🐯','🐨','🐻','🐷','🐽','🐮','🐗','🐵','🐒','🐴','🐑','🐘','🐼','🐧','🐦','🐤','🐥','🐣','🐔','🐍','🐢','🐛',
        '🐝','🐜','🐞','🐌','🐙','🐚','🐠','🐟','🐬','🐳','🐋','🐄','🐏','🐀','🐃','🐅','🐇','🐉','🐎','🐐','🐓','🐕','🐖',
        '🐁','🐂','🐲','🐡','🐊','🐫','🐪','🐆','🐈','🐩','🐾','💐','🌸','🌷','🍀','🌹','🌻','🌺','🍁','🍃','🍂','🌿','🌾',
        '🍄','🌵','🌴','🌲','🌳','🌰','🌱','🌼','🌐','🌞','🌝','🌑','🌒','🌓','🌔','🌕','🌖','🌗','🌘','🌜','🌛','🌙','🌍',
        '🌎','🌏','🌋','⭐','☀','⛅','☁','⚡','☔','⛄','🌀','🌈','🌊','🎍','💝','🎎','🎒','🎓','🎏','🎐','🎃','👻',
        '🎅','🎄','🎁','🎋','🎉','🎊','🎈','🎌','🔮','🎥','📷','📹','📼','💿','📀','💽','💾','💻','📱','📞','📟','📠','📡',
        '📺','📻','🔊','🔉','🔈','🔇','🔔','🔕','📢','📣','⏳','⌛','⏰','⌚','🔓','🔒','🔏','🔐','🔑','🔎','💡','🔦','🔆','🔅',
        '🔌','🔋','🔍','🛁','🛀','🚿','🚽','🔧','🔩','🔨','🚪','🚬','💣','🔫','🔪','💊','💉','💰','💴','💵','💷','💶','💳','💸',
        '📲','📧','📥','📤','✉','📩','📨','📯','📫','📪','📬','📭','📮','📦','📝','📄','📃','📑','📊','📈','📉','📜','📋','📇',
        '📁','📂','📌','📎','📏','📐','📕','📗','📘','📙','📓','📔','📒','📚','📖','🔖','📛','🔬','🔭','📰','🎨','🎬','🎤',
        '🎧','🎼','🎵','🎶','🎹','🎻','🎺','🎷','🎸','👾','🎮','🃏','🎴','🀄','🎲','🎯','🏈','🏀','⚽','⚾','🎾','🎱',
        '🏉','🎳','⛳','🚵','🚴','🏁','🏇','🏆','🎿','🏂','🏊','🏄','🎣','☕','🍵','🍶','🍼','🍺','🍻','🍸','🍹','🍷','🍴',
        '🍕','🍔','🍟','🍗','🍖','🍝','🍛','🍤','🍱','🍣','🍥','🍙','🍘','🍚','🍜','🍲','🍢','🍡','🍳','🍞','🍩','🍮','🍦',
        '🍨','🍧','🎂','🍰','🍪','🍫','🍬','🍭','🍯','🍎','🍏','🍊','🍋','🍒','🍇','🍉','🍓','🍑','🍈','🍌','🍐','🍍','🍠',
        '🍆','🍅','🌽','🏠','🏡','🏫','🏢','🏣','🏥','🏦','🏪','🏩','🏨','💒','⛪','🏬','🏤','🏯','🏰','⛺','🏭','🗼','🗻',
        '🗽','🎠','🎡','⛲','🎢','🚢','⛵','🚤','🚣','⚓','🚀','✈','💺','🚁','🚂','🚊','🚉','🚞','🚆','🚄','🚅','🚈','🚇','🚝','🚋','🚃','🚎','🚌','🚍','🚙','🚘','🚗','🚕','🚖','🚛','🚚','🚨','🚓','🚔','🚒','🚑','🚐','🚲','🚡','🚟','🚠','🚜','💈','🚏','🎫','🚦','🚥','🚧','🔰','⛽','🏮','🎰','♨','🗿','🎪','🎭','📍','🚩','🚻','🚹','🚺','🚼','🚾','🚰','🚮','♿','🚭','🛄','🛅','🛃','🉑','🆑','🆘','🆔','🚫','🔞','📵','🚯','🚱','🚳','🚷','🚸','⛔','❎','✅','✴','💟','🆚','📳','📴','🆎','💠','➿','🏧','💹','⭕','❗','❓','❕','❔','🔃','🕛','🕧','🕐','🕜','🕑','🕝','🕒','🕞','🕓','🕟','🕔','🕠','🕕','🕖','🕗','🕘','🕙','🕚','🕡','🕢','🕣','🕤','🕥','🕦','💮','🔘','🔗','➰','🔱','🔲','🔳','◾','◽','🔺','⬜','⬛','⚫','⚪','🔴','🔵','🔻','🔶','🔷','🔸','🔹'
],

    getRandomEmoji: function() {
        return this.emojis[Math.floor(Math.random() * this.emojis.length)];
    },
    getRandomRoundEmoji: function() {
        return this.roundSelection[Math.floor(Math.random() * this.roundSelection.length)];
    },
    getRandomRoundColor: function() {
        return this.roundColors[Math.floor(Math.random() * this.roundColors.length)];
    },
    getRandomSquareColor: function() {
        return this.squareColors[Math.floor(Math.random() * this.squareColors.length)];
    },
    getRandomAnimalEmoji: function() {
        return this.animals[Math.floor(Math.random() * this.roundSelection.length)];
    }
}

/* Cut and paste:
🔴,🟠,🟡,🟢,🔵,🟣,⚫️,⚪️,🟤,
🟥,🟧,🟨,🟩,🟦,🟪,⬛️,⬜️,🟫,
🌞,🌝,🌑,🌒,🌓,🌔,🌕,🌖,🌗,🌘,
📀,🌰,🍎,🍏,🏀,⚽,⚾,🎾,🎱,
🍪,🍥,🍘,🍅,🌼,🌐,🌞,🌍,🌎,🌏,💿,
🐶,🐱,🐭,🐹,🐰,🦊,🐻,🐼,🐻‍❄️,🐨,🐯,🦁,
🐮,🐷,🐵,🐔,🐧,🐦,🐤,🦄,🐣,🐥
,🦆,🦅,🦉,🦇,🐺,🐗,🐴,🐝,🪱,🐛,🦋,🐌
,🐞,🐜,🪰,🪲,🪳,🦟,🦗,🕷,🕸,🦂,
🐢,🐍,🦎,🦖,🦕,🐙,🦑,🦐,🦞,🦀,
🐡,🐠,🐟,🐬,🐳,🐋,🦈,🐊,🐅,🐆,🦓,
🦍,🦧,🦣,🐘,🦛,🦏,🐪,🐫,🦒,🦘,🦬,
🐃,🐂,🐄,🐎,🐖,🐏,🐑,🦙,🐐,🦌,🐕,🐩,
🦮,🐕‍🦺,🐈,🐈‍⬛,🐓,🦃,🦤,🦚,🦜,🦢,🦩,🕊,
🐇,🦝,🦨,🦡,🦫,🦦,🦥,🐁,🐀,🐿,🦔    

*/